import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../../state/modals-dux';

class DeleteAssetModal extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      openModal,
      closeModal,
      assetToDelete,
      handleDeleteAsset,
      deleteAssetInProgress,
      label
    } = this.props;
    return (
      <Modal show={openModal === 'DeleteAssetModal'} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Asset</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!deleteAssetInProgress &&
            <span>
              Are you sure you want to permanently delete {label || 'asset'}?
            </span>}
          {deleteAssetInProgress && <span>Loading ...</span>}
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="button"
            bsStyle="success"
            onClick={handleDeleteAsset}
            disabled={deleteAssetInProgress}
          >
            <span className="ti ti-check" /> Yes, Delete
          </Button>
          {' '}
          <Button
            type="button"
            bsStyle="hollow-info"
            onClick={closeModal}
            disabled={deleteAssetInProgress}
          >
            <span className="ti ti-close" /> Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapState = state => ({ openModal: state.modals });
const mapDispatch = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapState, mapDispatch)(DeleteAssetModal);



// WEBPACK FOOTER //
// ./src/components/routes/assets/DeleteAssetModal.js